import styled from 'styled-components';

export enum SizeType {
  SmallBlock = 'smallBlock',
  Block = 'block',
  SmallCard = 'smallCard',
  Card = 'card',
}

interface SizeMap {
  height: string;
  width: string;
}

const sizeMap: { [key in SizeType]: SizeMap } = {
  [SizeType.SmallBlock]: { height: '220px', width: '300px' },
  [SizeType.Block]: { height: '256px', width: '382px' },
  [SizeType.SmallCard]: { height: '320px', width: '382px' },
  [SizeType.Card]: { height: '470px', width: '382px' },
};

const getSizeStyles = (type: SizeType): SizeMap => sizeMap[type];

export const InfoBlockContainer = styled.div<{
  $type: SizeType;
  $alignCenter?: boolean;
}>`
  ${({ $type }) => {
    const { height, width } = getSizeStyles($type);
    return `
    height: ${height};
    width: ${width};
  `;
  }};
  display: flex;
  flex-direction: column;
  gap: ${({ $type }) =>
    $type === SizeType.Card || $type == SizeType.SmallCard ? '24px' : '12px'};
  align-items: ${({ $alignCenter }) =>
    $alignCenter ? 'center' : 'flex-start'};
  text-align: ${({ $alignCenter }) => ($alignCenter ? 'center' : 'left')};
  border-radius: 12px;
  border: ${({ theme, $type }) =>
    $type === SizeType.Card || $type == SizeType.SmallCard
      ? `1px solid ${theme.colors.default[100]}`
      : 'none'};
  padding: ${({ $type }) =>
    $type === SizeType.Card || $type == SizeType.SmallCard ? '24px' : '10'};
  box-shadow: ${({ $type }) =>
    $type === SizeType.Card || $type == SizeType.SmallCard
      ? '0px 1px 2px 0px rgba(16, 24, 40, 0.05);'
      : 'none'};

  ${({ theme }) => theme.breakpoints.lg.query} {
    align-items: center;
    text-align: center;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    width: 100%;

    p {
      font-size: ${({ $type }) =>
        $type === SizeType.Card || $type == SizeType.SmallCard
          ? '14px'
          : undefined};
    }
  }
`;
